import { Injectable, ErrorHandler } from '@angular/core';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/browser';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error) {
    if (/Loading chunk [\d]+ failed/.test(error.message)) {
      // Reload app if we detect a loading chunk error
      window.location.reload();
    } else if (environment.production) {
      // Log exception to Sentry
      Sentry.captureException(error.originalError || error);
    } else {
      // Show error in browser console as normal
      console.error(error);
    }
  }
}
